import React from "react";
import { isScoreBeta } from "../utils/beta";

/**
 * 새 디자인(미리 써보기) 공통 테마: 페이지 바탕·입력칸·제목을 새 색으로 맞춘다 (2026-10).
 * 페이지마다 따로 고치기 전, 예전 화면들도 같은 테마로 보이게 하는 덮개.
 */
const CSS = `
  /* 원래 어두운 화면이라고 브라우저에 알림 → 삼성 인터넷·크롬의 '다크 모드'가 색을 멋대로 바꾸지 않게 */
  :root { color-scheme: dark; }
  body { background: #0d0e12 !important; }
  input::placeholder, textarea::placeholder { color: #7c8392 !important; }
  h1 { letter-spacing: -0.3px; }
  @media (max-width: 1023px) {
    /* 아래쪽 메뉴 탭에 내용이 가리지 않게 */
    #root { padding-bottom: 62px; }
  }
`;

// 같은 이유로 <meta name="color-scheme" content="dark"> 도 넣는다
if (isScoreBeta() && typeof document !== "undefined" && !document.querySelector('meta[name="color-scheme"]')) {
  const m = document.createElement("meta");
  m.name = "color-scheme";
  m.content = "dark";
  document.head.appendChild(m);
}

const BetaGlobalStyle: React.FC = () => (isScoreBeta() ? <style>{CSS}</style> : null);

export default BetaGlobalStyle;
